import { getMarketFromHostname } from './footerLinks';

export const ROUTE_TRANSLATIONS = {
  no: {
    privacyPolicy: '/retningslinjer_for_personvern',
    termsOfUse: '/vilkar_for_bruk',
  },
  dk: {
    privacyPolicy: '/privatlivserklæring',
    termsOfUse: '/vilkar_for_brug',
  },
  sv: {
    privacyPolicy: '/integritetspolicy',
    termsOfUse: '/villkor_for_anvandning',
  },
};

export const getRouteTranslations = () =>
  ROUTE_TRANSLATIONS[getMarketFromHostname()];

const uniquePaths = (key) => [
  ...new Set(Object.values(ROUTE_TRANSLATIONS).map((routes) => routes[key])),
];

export const privacyPolicyPaths = uniquePaths('privacyPolicy');
export const termsOfUsePaths = uniquePaths('termsOfUse');
